import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import styled, { css } from 'styled-components';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import noop from '@userzoomlibraries/toolkit-js-utils/noop';
import React from 'react';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { C as Content } from './index.styled2.js';
import { jsx } from 'react/jsx-runtime';

var _excluded$1 = ["className", "invalid", "children", "onClick", "onTouchStart", "onTouchEnd", "onMouseDown", "onMouseUp", "onKeyUp", "onKeyDown", "onMouseEnter", "onMouseLeave"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Card$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      invalid = _ref.invalid,
      children = _ref.children,
      onClick = _ref.onClick,
      onTouchStart = _ref.onTouchStart,
      onTouchEnd = _ref.onTouchEnd,
      onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      onKeyUp = _ref.onKeyUp,
      onKeyDown = _ref.onKeyDown,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      rest = _objectWithoutProperties$1(_ref, _excluded$1);

  var dataAttributes = useDataAttributes(rest);
  return /*#__PURE__*/jsx("div", _objectSpread$1(_objectSpread$1({
    className: "gz-card ".concat(className),
    ref: ref,
    onClick: onClick,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "aria-invalid": invalid // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes), {}, {
    children: children
  }));
});
Card$1.COMPONENT_ID = 'Gearz.Card';
Card$1.displayName = Card$1.COMPONENT_ID;
Card$1.Content = Content;
Card$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  children: PropTypes.oneOfTypeWithDescription([PropTypes.node, PropTypes.func], 'Content of the card.'),
  invalid: PropTypes.boolWithDescription('Flag to make the card invalid.'),
  onClick: PropTypes.funcWithDescription('Callback called when click event is triggered.'),
  onTouchStart: PropTypes.funcWithDescription('Callback called when touchstart event is triggered.'),
  onTouchEnd: PropTypes.funcWithDescription('Callback called when touchend event is triggered.'),
  onMouseDown: PropTypes.funcWithDescription('Callback called when mousedown event is triggered.'),
  onMouseUp: PropTypes.funcWithDescription('Callback called when mouseup event is triggered.'),
  onKeyUp: PropTypes.funcWithDescription('Callback called when keyup event is triggered.'),
  onKeyDown: PropTypes.funcWithDescription('Callback called when keydown event is triggered.'),
  onMouseEnter: PropTypes.funcWithDescription('Callback called when mouseenter event is triggered.'),
  onMouseLeave: PropTypes.funcWithDescription('Callback called when mouseleave event is triggered.')
};
Card$1.defaultProps = {
  className: '',
  children: null,
  invalid: false,
  onClick: noop,
  onTouchStart: noop,
  onTouchEnd: noop,
  onMouseDown: noop,
  onMouseUp: noop,
  onKeyUp: noop,
  onKeyDown: noop,
  onMouseEnter: noop,
  onMouseLeave: noop
};

var _excluded = ["disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var isEmptyFunction = function isEmptyFunction(func) {
  return func === noop;
};

var isInteractive = function isInteractive(_ref) {
  var onClick = _ref.onClick,
      onTouchStart = _ref.onTouchStart,
      onTouchEnd = _ref.onTouchEnd,
      onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      onKeyUp = _ref.onKeyUp,
      onKeyDown = _ref.onKeyDown,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  return !isEmptyFunction(onClick) || !isEmptyFunction(onTouchStart) || !isEmptyFunction(onTouchEnd) || !isEmptyFunction(onMouseDown) || !isEmptyFunction(onMouseUp) || !isEmptyFunction(onKeyUp) || !isEmptyFunction(onKeyDown) || !isEmptyFunction(onMouseEnter) || !isEmptyFunction(onMouseLeave);
};

var getInteractiveStyles = function getInteractiveStyles(_ref2) {
  var disabled = _ref2.disabled,
      callbacks = _objectWithoutProperties(_ref2, _excluded);

  return isInteractive(callbacks) && css(["", " ", ""], disabled && css(["cursor:not-allowed;opacity:0.4;"]), !disabled && css(["cursor:pointer;"]));
};

var Card = styled(Card$1).withConfig({
  componentId: "gz-card-1679041956437__sc-1r50g4w-0"
})(["background-color:#ffffff;border:1px solid #000000;position:relative;", " ", ""], function (props) {
  return getInteractiveStyles(props);
}, function (props) {
  return getThemeByProps({
    componentId: Card$1.COMPONENT_ID,
    props: props
  });
});
Card.displayName = Card$1.displayName;
Card.propTypes = _objectSpread(_objectSpread({}, Card$1.propTypes), {}, {
  disabled: PropTypes.boolWithDescription('Flag to make the card disable.')
});
Card.defaultProps = _objectSpread(_objectSpread({}, Card$1.defaultProps), {}, {
  disabled: false
});

export { Card as C };
